export const SET_BUTTON_VISIBLE = 'SET_BUTTON_VISIBLE'
export const BUTTON_TOGGLE = 'BUTTON_TOGGLE'
